module.exports = __webpack_public_path__ + "static/media/sign-up-couch.7f06a0a9.png";